import React, { useState } from 'react'
import { Row, Col, Image, Modal } from 'antd'
import profile from '../../assets/img/profile.png'
import { UserWrapper } from '../../components'
import { maskCep } from '../../utils/functions'
import { downloadFile } from '../../utils/functions'
import { ReactComponent as iconDownload } from '../../assets/img/download.svg'
import { ReactComponent as iconEye } from '../../assets/img/eye.svg'
import { ButtonComponent as Button } from '../../components'
import ModalDocs from '../users-pending/modalDocs'

const UserInfo = (props) => {
    const { user, isLoading, success } = props
    const [openModal, setOpenModal] = useState(false)
    const [docType, setDocType] = useState(1)

    const handleOpenModal = (type) => {
        setDocType(type)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const handleType = (type) => {
        setDocType(type)
    }

    const handleConfirm = () => {
        // Função vazia para compatibilidade com o componente ModalDocs
    }

    return (
        <>
            {isLoading ? 'Carregando...' : !success ? 'Houve um erro ao carregar as informações' :
            <>
            <Row id="dados">
                <Col md={4}>
                    <Image src={profile} preview={false} className="profile-pic" />
                </Col>
                <Col md={20}>
                    <UserWrapper user={user} />
                </Col>
            </Row>
            <Row id="documentos" className="mt-25">
                <Col md={4}>
                    <label className="tx-placeholder font-bold">Documentos</label>
                </Col>
                <Col md={20} className="d-flex flex-column">
                    <hr className="profile-divisor" />
                    <div className="d-flex justify-between mt-25 pl-20 pr-20">
                        <div className="w-50">
                            <label className="tx-pink font-bold">Documento de Identidade</label><br />
                            <div className="mt-10 d-flex">
                                <Button 
                                    icon={iconDownload} 
                                    type="primary" 
                                    onClick={() => downloadFile(user.documento)} 
                                    disabled={!user.documento}
                                    className="mr-10"
                                >
                                    Download
                                </Button>
                                <Button 
                                    icon={iconEye} 
                                    type="primary" 
                                    onClick={() => handleOpenModal(1)} 
                                    disabled={!user.documento}
                                >
                                    Visualizar
                                </Button>
                            </div>
                        </div>
                        <div className="w-50">
                            <label className="tx-pink font-bold">Comprovante de Residência</label><br />
                            <div className="mt-10 d-flex">
                                <Button 
                                    icon={iconDownload} 
                                    type="primary" 
                                    onClick={() => downloadFile(user.comprovanteEndereco)} 
                                    disabled={!user.comprovanteEndereco}
                                    className="mr-10"
                                >
                                    Download
                                </Button>
                                <Button 
                                    icon={iconEye} 
                                    type="primary" 
                                    onClick={() => handleOpenModal(2)} 
                                    disabled={!user.comprovanteEndereco}
                                >
                                    Visualizar
                                </Button>
                            </div>
                        </div>
                        <div className="w-50">
                            <label className="tx-pink font-bold">Selfie com documento</label><br />
                            <div className="mt-10 d-flex">
                                <Button 
                                    icon={iconDownload} 
                                    type="primary" 
                                    onClick={() => downloadFile(user.selfie)} 
                                    disabled={!user.selfie}
                                    className="mr-10"
                                >
                                    Download
                                </Button>
                                <Button 
                                    icon={iconEye} 
                                    type="primary" 
                                    onClick={() => handleOpenModal(3)} 
                                    disabled={!user.selfie}
                                >
                                    Visualizar
                                </Button>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row id="residencia" className="mt-25">
                <Col md={4}>
                    <label className="tx-placeholder font-bold">Residência</label>
                </Col>
                <Col md={20} className="d-flex flex-column">
                    <hr className="profile-divisor" />
                    <div className="d-flex justify-between mt-25 pl-20 pr-20">
                        <div className="w-50">
                            <label className="tx-pink font-bold">Endereço</label><br />
                            <label className="tx-gray">{user.endereco}</label>
                        </div>
                        <div className="w-25">
                            <label className="tx-pink font-bold">Número</label><br />
                            <label className="tx-gray">{user.numero}</label>
                        </div>
                        <div className="w-25">
                            <label className="tx-pink font-bold">Complemento</label><br />
                            <label className="tx-gray">{user.complemento}</label>
                        </div>
                    </div>
                    <div className="d-flex justify-between mt-30 pl-20 pr-20">
                        <div className="w-50">
                            <label className="tx-pink font-bold">Cidade/Estado</label><br />
                            <label className="tx-gray">{user.cidade} - {user.estado}</label>
                        </div>
                        <div className="w-50">
                            <label className="tx-pink font-bold">CEP</label><br />
                            <label className="tx-gray">{maskCep(user.cep)}</label>
                        </div>
                    </div>
                </Col>
            </Row>

            <Modal
                visible={openModal}
                width="95vw"
                centered
                footer={null}
                closable={false}
                maskClosable={false}
                className="modal-docs"
            >
                <ModalDocs 
                    user={user} 
                    type={docType} 
                    handleType={handleType} 
                    closeModal={handleCloseModal} 
                    handleConfirm={handleConfirm} 
                />
            </Modal>
            </>}
        </>
    )
}

export default UserInfo